export const arrowRightLightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M5.649 24a.5.5 0 0 1-.331-.874L17.893 12 5.318.875a.501.501 0 0 1 .662-.75l12.576 11.126a1.003 1.003 0 0 1 .001 1.496L5.98 23.875a.5.5 0 0 1-.331.125"/></svg>`,
    name: 'arrow-right-light'
};